/**
 * CLEANEASE PREMIUM v4.2 — Animations & UI enhancements
 * ─────────────────────────────────────────────────────
 * SAFE FOR: Shopify Theme Editor · OS 2.0 · Checkout · Cart
 * DOES NOT: intercept links, modify forms, change routes,
 *           redirect URLs, override Shopify checkout JS
 */
(function () {
  'use strict';

  var isDesignMode = document.documentElement.classList.contains('shopify-design-mode');

  /* ── Inject animation keyframes ── */
  function injectKeyframes() {
    if (document.getElementById('prem-kf')) return;
    var s = document.createElement('style');
    s.id = 'prem-kf';
    s.textContent = [
      '@keyframes premRipple{to{transform:translate(-50%,-50%) scale(3.5);opacity:0}}',
      '@keyframes premBounce{0%{transform:scale(1)}40%{transform:scale(1.45)}70%{transform:scale(0.9)}100%{transform:scale(1)}}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ── Scroll reveal — purely visual ── */
  function initReveal() {
    if (!window.IntersectionObserver) return;
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('in-view');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    document.querySelectorAll('.prem-t article').forEach(function(el, i) {
      el.classList.add('reveal');
      el.style.transitionDelay = Math.min((i % 4) * 0.07, 0.28) + 's';
      io.observe(el);
    });
  }

  /* ── Navbar scroll glass effect ── */
  function initNavbar() {
    var h = document.querySelector('header-component');
    if (!h) return;
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          h.toggleAttribute('scrolled', window.scrollY > 30);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── Button ripple (visual only, no form interference) ── */
  function initRipples() {
    if (isDesignMode) return; // skip in editor
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.button--primary');
      if (!btn) return;
      // Never ripple on checkout, cart-submit, or payment buttons
      if (
        btn.closest('#checkout') ||
        btn.closest('[name="checkout"]') ||
        btn.closest('.cart__checkout-button') ||
        btn.closest('.shopify-payment-button') ||
        btn.closest('shopify-accelerated-checkout') ||
        btn.closest('shopify-accelerated-checkout-cart') ||
        (btn.type === 'submit' && btn.form && (
          btn.form.id === 'cart-form' ||
          btn.form.action.indexOf('/cart') > -1 ||
          btn.form.action.indexOf('checkout') > -1
        ))
      ) return;

      var r = btn.getBoundingClientRect();
      var span = document.createElement('span');
      span.style.cssText = [
        'position:absolute',
        'left:' + (e.clientX - r.left) + 'px',
        'top:' + (e.clientY - r.top) + 'px',
        'transform:translate(-50%,-50%) scale(0)',
        'width:100px',
        'height:100px',
        'background:rgba(255,255,255,0.15)',
        'border-radius:50%',
        'pointer-events:none',
        'z-index:0',
        'animation:premRipple 0.5s ease-out forwards'
      ].join(';');
      btn.appendChild(span);
      setTimeout(function() { if (span.parentNode) span.parentNode.removeChild(span); }, 600);
    });
  }

  /* ── Cart count bounce (purely visual) ── */
  function initCartBounce() {
    var b = document.querySelector('.cart-bubble, .cart-count-bubble');
    if (!b) return;
    new MutationObserver(function() {
      b.style.animation = 'none';
      void b.offsetHeight;
      b.style.animation = 'premBounce 0.4s cubic-bezier(0.34,1.56,0.64,1) both';
    }).observe(b, { childList: true, subtree: true });
  }

  /* ── Init ── */
  function init() {
    injectKeyframes();
    initReveal();
    initNavbar();
    initRipples();
    initCartBounce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify section editor reload support
  document.addEventListener('shopify:section:load', function() {
    initReveal();
  });

})();
